import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
    {
      name: "Beaver Creek",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
      artist: "Aso, Middle School, Aviino",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10075",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Daylight",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
      artist: "Aiguille",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9272",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Keep Going",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      artist: "Swørn",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9222",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Nightfall",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
      artist: "Aiguille",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9148",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Reflection",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      artist: "Swørn",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9228",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Under the City Stars",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
      artist: "Aso, Middle School, Aviino",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10074",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
        name: "Far From Home",
        cover: 
            "https://chillhop.com/wp-content/uploads/2020/12/7e98d3028a22ee7f16f6a9bfcdc2089f089777a5-1024x1024.jpg",
        artist: "Toonorth",
        audio: "https://mp3.chillhop.com/serve.php/?mp3=8127",
        color: ['#304187','#DE7E77'],
        id: uuidv4(),
        active: false,  
    },
    {
      name: "Flashback",
      cover: 
          "https://chillhop.com/wp-content/uploads/2020/12/33a2a875828118a3ff260638a88362936104879a-1024x1024.jpg",
      artist: "Blue Wednesday, Shopan",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=11225",
      color: ['#A870A1','#4F5FAC'],
      id: uuidv4(),
      active: false,  
  },
  {
    name: "Déjà Vu",
    cover: 
        "https://chillhop.com/wp-content/uploads/2020/12/33a2a875828118a3ff260638a88362936104879a-1024x1024.jpg",
    artist: "Blue Wednesday, Shopan",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=11229",
    color: ['#A870A1','#4F5FAC'],
    id: uuidv4(),
    active: false,  
  },
  {
    name: "Toofpick",
    cover: 
        "https://chillhop.com/wp-content/uploads/2020/12/33a2a875828118a3ff260638a88362936104879a-1024x1024.jpg",
    artist: "Blue Wednesday, Shopan",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=11227",
    color: ['#A870A1','#4F5FAC'],
    id: uuidv4(),
    active: false,  
  },
  {
    name: "Day One",
    cover: 
        "https://chillhop.com/wp-content/uploads/2020/12/33a2a875828118a3ff260638a88362936104879a-1024x1024.jpg",
    artist: "Blue Wednesday, Shopan",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=11231",
    color: ['#A870A1','#4F5FAC'],
    id: uuidv4(),
    active: false,  
  },
  {
    name: "Bloom",
    cover: 
        "https://chillhop.com/wp-content/uploads/2020/12/33a2a875828118a3ff260638a88362936104879a-1024x1024.jpg",
    artist: "Blue Wednesday, Shopan",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=11235",
    color: ['#A870A1','#4F5FAC'],
    id: uuidv4(),
    active: false,  
  },
  {
    name: "Murmuration",
    cover: 
        "https://chillhop.com/wp-content/uploads/2020/12/33a2a875828118a3ff260638a88362936104879a-1024x1024.jpg",
    artist: "Blue Wednesday, Shopan",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=11235",
    color: ['#A870A1','#4F5FAC'],
    id: uuidv4(),
    active: false,  
  },
  {
    name: "Lax Incense",
    cover: 
        "https://chillhop.com/wp-content/uploads/2021/01/6b1bb8736ee3e972747bc11f312e31cf7f5823e4-1024x1024.jpg",
    artist: "Mama Aiuto, Daphné",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=12125",
    color: ['#531E1A','#587D1B'],
    id: uuidv4(),
    active: false,  
},
{
  name: "Small Town Palm Trees",
  cover: 
      "https://chillhop.com/wp-content/uploads/2021/01/6b1bb8736ee3e972747bc11f312e31cf7f5823e4-1024x1024.jpg",
  artist: "Mama Aiuto",
  audio: "https://mp3.chillhop.com/serve.php/?mp3=12124",
  color: ['#531E1A','#587D1B'],
  id: uuidv4(),
  active: false,  
},
{
  name: "Today Feels Like Everyday",
  cover: 
      "https://chillhop.com/wp-content/uploads/2021/01/6b1bb8736ee3e972747bc11f312e31cf7f5823e4-1024x1024.jpg",
  artist: "Mama Aiuto",
  audio: "https://mp3.chillhop.com/serve.php/?mp3=12128",
  color: ['#531E1A','#587D1B'],
  id: uuidv4(),
  active: false,  
},
{
  name: "Where The Streets Are Cold",
  cover: 
      "https://chillhop.com/wp-content/uploads/2021/01/6b1bb8736ee3e972747bc11f312e31cf7f5823e4-1024x1024.jpg",
  artist: "Mama Aiuto",
  audio: "https://mp3.chillhop.com/serve.php/?mp3=12129",
  color: ['#531E1A','#587D1B'],
  id: uuidv4(),
  active: false,  
},
{
  name: "Hereafter",
  cover: 
      "https://chillhop.com/wp-content/uploads/2020/11/f78c39b4bb6313ddd0354bef896c591bfb490ff8-1024x1024.jpg",
  artist: "Makzo",
  audio: "https://mp3.chillhop.com/serve.php/?mp3=11770",
  color: ['#FABB64','#2A5A9B'],
  id: uuidv4(),
  active: false,  
},
{
  name: "Melancholy",
  cover: 
      "https://chillhop.com/wp-content/uploads/2020/11/f78c39b4bb6313ddd0354bef896c591bfb490ff8-1024x1024.jpg",
  artist: "Makzo",
  audio: "https://mp3.chillhop.com/serve.php/?mp3=11778",
  color: ['#FABB64','#2A5A9B'],
  id: uuidv4(),
  active: false,  
},
{
  name: "Oasis",
  cover: 
      "https://chillhop.com/wp-content/uploads/2020/11/f78c39b4bb6313ddd0354bef896c591bfb490ff8-1024x1024.jpg",
  artist: "Makzo",
  audio: "https://mp3.chillhop.com/serve.php/?mp3=11768",
  color: ['#FABB64','#2A5A9B'],
  id: uuidv4(),
  active: false,  
},
{
  name: "Longing",
  cover: 
      "https://chillhop.com/wp-content/uploads/2020/11/f78c39b4bb6313ddd0354bef896c591bfb490ff8-1024x1024.jpg",
  artist: "Makzo",
  audio: "https://mp3.chillhop.com/serve.php/?mp3=11777",
  color: ['#FABB64','#2A5A9B'],
  id: uuidv4(),
  active: false,  
},
{
  name: "Departure",
  cover: 
      "https://chillhop.com/wp-content/uploads/2020/11/f78c39b4bb6313ddd0354bef896c591bfb490ff8-1024x1024.jpg",
  artist: "Makzo",
  audio: "https://mp3.chillhop.com/serve.php/?mp3=11771",
  color: ['#FABB64','#2A5A9B'],
  id: uuidv4(),
  active: false,  
},
  ];
}

export default chillHop;